import {SearchFeature} from './SearchFeature';
import {FeatureCollection} from 'geojson';
import {SourceSpecification} from '@maplibre/maplibre-gl-style-spec';
import {Metadata, VersionMetadata} from './Metadata';

export type DATA_SOURCE_STATUS = 'DEACTIVATED' | 'LOADING_DATA' | 'UPDATE_OUT_OF_SYNC' | 'ACTIVE';
export const DATA_SOURCE_STATUS_DEACTIVATED: DATA_SOURCE_STATUS = 'DEACTIVATED';
export const DATA_SOURCE_STATUS_LOADING_DATA: DATA_SOURCE_STATUS = 'LOADING_DATA';
export const DATA_SOURCE_STATUS_UPDATE_OUT_OF_SYNC: DATA_SOURCE_STATUS = 'UPDATE_OUT_OF_SYNC';
export const DATA_SOURCE_STATUS_ACTIVE: DATA_SOURCE_STATUS = 'ACTIVE';

export type DataSourceId = 'avg' | 'fcd' | 'situation-otis' | 'fd'
    | 'traveltime-fcd' | 'traveltime-drips' | 'traveltime-other'
    | 'hectometrePost';

interface BaseDataSource<DataType, Metadata> extends StreamableDataSource {
    id: DataSourceId;
    name: string;
    loadBaseData: boolean;
    refreshUpdate: boolean;
    sourceLayer: string;
    dataLoadMethod: string;
    updateInterval: number;
    sourceConfiguration: SourceSpecification;
    layerFilteredMapData: DataType | null;
    layerMapData: DataType | null;
    isActive: boolean;
    status: DATA_SOURCE_STATUS;
    searchProperty: string;
    searchFeatures: SearchFeature[];
    metadata: Metadata | null;
    websocketReload: boolean;
    colorBlindSupported: boolean;
    currentIdentifier: number | null;
    sourceUpdateIdentifier: number | null;
    lastUpdateReceived: number | null;
    streamable: boolean;
    searchOptionSource: string | null;
}

interface StreamableDataSource {
    websocketUrl: string;
    lastSnapshotUpdateTimestamp: number | null;
    dataStreamerId: string;
}

export interface DataSourceGeoJson extends BaseDataSource<FeatureCollection, Metadata> {
    dataLoadMethod: 'GeoJSON';
}

export interface DataSourceVectorTiles extends BaseDataSource<Record<string, unknown>, VersionMetadata> {
    dataLoadMethod: 'VectorTiles';
}

export type DataSource = DataSourceGeoJson | DataSourceVectorTiles;
